module.exports = "<div class=\"kyc-loading-overlay\" *ngIf=\"visible$ | async\">\r\n  <div class=\"kyc-loading-center\">\r\n    <span class=\"glyphicon glyphicon-refresh kyc-loading-spinner\" role=\"status\" aria-hidden=\"true\"></span>\r\n    <div class=\"kyc-loading-text\">\r\n      <span class=\"sr-only\">Loading...</span>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loading-overlay/loading-overlay.component.html
// module id = ./src/app/shared/loading-overlay/loading-overlay.component.html
// module chunks = main